import { STUDY_CATEGORIES } from "../constants/categories";
import BackButton from "./BackButton";
import {
    BUZZER_SESSION_LENGTHS,
    STUDY_SESSION_LENGTHS,
} from "../constants/sessionSettings";

export default function SettingsScreen({
    selectedCategoryIds,
    onChange,
    buzzerSessionLength,
    onBuzzerSessionLengthChange,
    studySessionLength,
    onStudySessionLengthChange,
    onBack,
}) {
    function toggleCategory(categoryId) {
        if (selectedCategoryIds.includes(categoryId)) {
            onChange(
                selectedCategoryIds.filter((id) => id !== categoryId)
            );
        } else {
            onChange([
                ...selectedCategoryIds,
                categoryId,
            ]);
        }
    }

    function selectAll() {
        onChange(
            STUDY_CATEGORIES.map((category) => category.id)
        );
    }

    function clearAll() {
        onChange([]);
    }

    return (
        <div className="page-screen">
            <div className="page-content">
                <div className="page-toolbar">
                    <BackButton onClick={onBack} />
                </div>

                <header className="page-header">
                    <h1>Settings</h1>
                </header>

                <section className="settings-card">
                    <div className="settings-card__header">
                        <div>
                            <h2>Session Length</h2>
                            <p>
                                Choose how many clues appear in each training session.
                            </p>
                        </div>
                    </div>

                    <div className="settings-session-length">
                        <div className="settings-session-length__group">
                            <div className="settings-session-length__label">
                                Buzzer Mode
                            </div>

                            <div className="settings-session-length__options">
                                {BUZZER_SESSION_LENGTHS.map((length) => (
                                    <button
                                        key={length}
                                        type="button"
                                        className={
                                            buzzerSessionLength === length
                                                ? "settings-session-length__option settings-session-length__option--selected"
                                                : "settings-session-length__option"
                                        }
                                        onClick={() =>
                                            onBuzzerSessionLengthChange(length)
                                        }
                                    >
                                        {length}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="settings-session-length__group">
                            <div className="settings-session-length__label">
                                Study Mode
                            </div>

                            <div className="settings-session-length__options">
                                {STUDY_SESSION_LENGTHS.map((length) => (
                                    <button
                                        key={length}
                                        type="button"
                                        className={
                                            studySessionLength === length
                                                ? "settings-session-length__option settings-session-length__option--selected"
                                                : "settings-session-length__option"
                                        }
                                        onClick={() =>
                                            onStudySessionLengthChange(length)
                                        }
                                    >
                                        {length}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="settings-card">
                    <div className="settings-card__header">
                        <div>
                            <h2>Study Mode Categories</h2>
                            <p>
                                Choose which categories can appear in Study mode.
                                Buzzer mode is not affected.
                            </p>
                        </div>
                    </div>

                    <div className="settings-category-toolbar">
                        <div className="settings-category-actions">
                            <button type="button" onClick={selectAll}>
                                Select All
                            </button>

                            <button type="button" onClick={clearAll}>
                                Clear All
                            </button>
                        </div>

                        <span className="settings-category-count">
                            {selectedCategoryIds.length} of {STUDY_CATEGORIES.length} selected
                        </span>
                    </div>

                    <div className="settings-category-grid">
                        {STUDY_CATEGORIES.map((category) => (
                            <label
                                key={category.id}
                                className={`settings-category-option ${selectedCategoryIds.includes(category.id)
                                    ? "settings-category-option--selected"
                                    : ""
                                    }`}
                            >
                                <input
                                    type="checkbox"
                                    checked={selectedCategoryIds.includes(category.id)}
                                    onChange={() => toggleCategory(category.id)}
                                />

                                <span>{category.name}</span>
                            </label>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    );
}